<template>
  <ul>
    <li v-for="option in options">
      <button
        class="grid grid-cols-[1fr_2rem] items-center w-full px-2 py-1 rounded-md gap-2"
        :class="{
          'canhover:hover:bg-neutral-300 canhover:hover:dark:bg-neutral-700 text-neutral-700 dark:text-neutral-300':
            !modelValue.includes(option.value),
          'canhover:hover:bg-nami-comi-blue/30 text-nami-comi-blue':
            modelValue.includes(option.value),
        }"
        @click="toggleOption(option)"
      >
        <div>
          <p
            class="text-left"
            :class="[modelValue.includes(option.value) && 'font-semibold']"
          >
            {{ option.text }}
          </p>
          <p
            v-if="option.description"
            class="text-left text-xs font-light text-neutral-600 dark:text-neutral-400"
          >
            {{ option.description }}
          </p>
        </div>
        <IconCheck v-if="modelValue.includes(option.value)" />
      </button>
    </li>
  </ul>
</template>

<script setup lang="ts" generic="T">
import { IconCheck } from "@tabler/icons-vue";

export type Option<T> = {
  text: string;
  value: T;
  description?: string;
  exclusive?: boolean;
};

export type Props<T> = {
  modelValue: T[];
  options: Option<T>[];
};

const props = defineProps<Props<T>>();

const emit = defineEmits<{
  (e: "update:modelValue", v: T[]): void;
}>();

if (props.options.filter((o) => o.exclusive).length > 1) {
  console.warn(
    "SelectModalMultiple:",
    "Having more than one exclusive option can lead to bugs",
  );
}

function toggleOption(option: Option<T>) {
  const foundIndex = props.modelValue.indexOf(option.value);

  if (foundIndex !== -1) {
    props.modelValue.splice(foundIndex, 1);
  } else {
    const exclusive = props.options
      .filter((o) => o.exclusive)
      .map((o) => o.value)
      .at(0);

    if (exclusive) {
      if (option.exclusive) {
        props.modelValue.splice(0, props.modelValue.length);
      } else if (props.modelValue.includes(exclusive)) {
        props.modelValue.splice(props.modelValue.indexOf(exclusive), 1);
      }
    }

    props.modelValue.push(option.value);
  }
}
</script>
